<ng-container *ngIf="(loaderService.isLoading | async) || !isLoaded">
  <app-flight-result-loader></app-flight-result-loader>
</ng-container>
<div class="shorting" *ngIf="!(loaderService.isLoading | async) && flightjourneys && flightjourneys.length > 0">
  <div class="shortFirst">
    <button mat-button>Sort By:</button>
  </div>
  <div class="shortMiddle">
    <div class="middleFirst" (click)="sortByDepart()">
      <button mat-button [ngClass]="isDepart?'activeColor':''">Depart
        <mat-icon class="material-icons"> {{isDepart ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
      </button>
    </div>
    <div class="middleSecond" (click)="sortByDuration()">
      <button mat-button [ngClass]="isDuration?'activeColor':''">Duration
        <mat-icon class="material-icons"> {{isDuration ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
      </button>
    </div>
    <div class="middleThird" (click)="sortByArrive()">
      <button mat-button [ngClass]="isArrive?'activeColor':''">Arrive
        <mat-icon class="material-icons"> {{isArrive ? 'arrow_downward' : 'arrow_upward'}}</mat-icon>
      </button>
    </div>
  </div>
  <div class="shortSecondLast" (click)="sortByPrice()">
    <button mat-button [ngClass]="isAsc?'activeColor':''">Price<mat-icon class="material-icons"> {{isAsc ?
        'arrow_downward' :
        'arrow_upward'}}</mat-icon>
    </button>
  </div>
  <div class="shortLast"></div>
</div>
<section class="itinerarySction" *ngIf="!(loaderService.isLoading | async)">
  <ng-container *ngFor="let item of flightjourneys;let i = index">
    <mat-card>
      <ng-container *ngFor="let subItem of item.flightlegs">
        <div class="flightInformation">
          <div class="flightInfo web_view">
            <img
              [src]="subItem[0]?.carrierImage ? subItem[0]?.carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
              [alt]="subItem[0].carriername" class="img-fluid"
              onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
            <div class="carrierInfo">
              <p class="carriername">{{subItem[0].carriername}}</p>
              <p class="carrierNumber">
                {{subItem[0].carrier}}-{{subItem[0].flightnumber}}<span *ngIf="subItem.length === 2"
                  class="stopageVia">,&nbsp;{{subItem[1].carrier}}-{{subItem[1].flightnumber}}</span>
                <span *ngIf="subItem.length === 3"
                  class="stopageVia">,&nbsp;{{subItem[2].carrier}}-{{subItem[2].flightnumber}}</span>
              </p>
            </div>
          </div>
          <div class="flightTimeInfo">
            <div class="middleFirst">
              <p>{{utilities.transfromTimeToHourMin(subItem[0].deptime)}}<br><span>{{subItem[0].origin_name.slice(0,
                  -5)}}</span></p>
            </div>
            <div class="middleSecond">
              <div class="timeDuration">
                <p>{{item.totaljourneyduration * 1000 * 60 | date: 'H' : 'UTC'}}h {{item.totaljourneyduration * 1000 *
                  60 | date: 'm' : 'UTC'}}m
                </p>
                <!-- <p *ngIf="subItem.length === 2">{{subItem[0].journeyduration + subItem[1].journeyduration * 1000 * 60 |
                  date: 'h' : 'UTC'}}h {{subItem[0].journeyduration + subItem[1].journeyduration * 1000 * 60 |
                  date: 'm' : 'UTC'}}m</p>
                <p *ngIf="subItem.length === 3">{{subItem[0].journeyduration + subItem[1].journeyduration * 1000 * 60 |
                  date: 'h' : 'UTC'}}h {{subItem[0].journeyduration + subItem[1].journeyduration * 1000 * 60 |
                  date: 'm' : 'UTC'}}m</p> -->
                <div class="distanceLine">
                  <span></span>
                  <span *ngIf="subItem.length === 2" class="stopagePoint"><span class="one-stop"></span></span>
                </div>
                <ng-container>
                  <p *ngIf="subItem.length === 1" class="stopageVia">Non stop</p>
                  <p *ngIf="subItem.length === 2" class="stopageVia"><b>1 Stop </b>via {{subItem[1].origin_name.slice(0,
                    -5)}}
                  <p *ngIf="subItem.length === 3" class="stopageVia" matTooltip=" {{subItem[1].origin_name.slice(0,
                    -5)}} and {{subItem[2]?.origin_name.slice(0, -5)}}"><b>2 Stops </b>via
                    {{subItem[1].origin_name.slice(0,
                    -5)}}
                    and ...
                  </p>
                  <!-- {{subItem[2]?.origin_name.slice(0, -5)}} -->
                </ng-container>
              </div>
            </div>
            <div class="middleThird">
              <!-- {{subItem | json}} -->
              <ng-container>
                <p *ngIf="subItem.length === 1">
                  {{utilities.transfromTimeToHourMin(subItem[0].arrtime)}}<br><span>{{subItem[0].destination_name.slice(0,
                    -5)}}</span></p>
                <p *ngIf="subItem.length === 2">
                  {{utilities.transfromTimeToHourMin(subItem[1].arrtime)}}<br><span>{{subItem[1].destination_name.slice(0,
                    -5)}}</span></p>
                <p *ngIf="subItem.length === 3">
                  {{utilities.transfromTimeToHourMin(subItem[2].arrtime)}}<br><span>{{subItem[2].destination_name.slice(0,
                    -5)}}</span></p>
              </ng-container>
            </div>
          </div>
          <div class="flightTotlalPrice">
            <p>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
              item.flightfare.infantbasefare + item.flightfare.adulttax +
              item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true: '2.0-0'
              }}</p>

            <!--(click)="bookFlight(item)"-->
            <!-- <div class="mfare" (click)="shoeMorefare(i)" *ngIf="!morefare[i]">More fares</div> -->
            <!-- <div class="mfare" (click)="shoeMorefare(i)" *ngIf="morefare[i]">Hide fares</div> -->

          </div>
          <!--<p class="additional">
            + More Fares</p>-->


          <div class="flight_booking_btn">
            <button class="secoundaryBtn" mat-flat-button (click)="bookFlight(item)">Book </button>
          </div>

        </div>
      </ng-container>

      <!--More fare detail-->

      <!-- <ng-container>
        <div class="fare-holder" *ngIf="morefare[i]">
          <div class="super-save" [ngClass]="{'switchicon': selectedPriceType === 'superSaver'}">
            <div class="super-saver-top">
              <div class="super">
                <div class="radio-holder" (click)="togglePrice('superSaver')">
                  <mat-radio-button value="1" [checked]="selectedPriceType === 'superSaver'">Super Saver</mat-radio-button>
                </div>
                <div class="pricing">
                  <p>
                    {{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                    item.flightfare.infantbasefare + item.flightfare.adulttax +
                    item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                    '2.0-0'
                    }}
                  </p>
                </div>
              </div>
            </div>

            <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'superSaver'}">
              <mat-list class="item-lst" role="list">
                <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                <mat-list-item role="listitem">Cancellation fees apply</mat-list-item>
                <mat-list-item role="listitem">Check-in baggage included</mat-list-item>
                <mat-list-item role="listitem">Date change chargeable</mat-list-item>
              </mat-list>
            </div>
          </div>
          <div class="super-save" [ngClass]="{'switchicon': selectedPriceType === 'flexPlus'}">
            <div class="super-saver-top">
              <div class="super">
                <div class="radio-holder" (click)="togglePrice('flexPlus')">
                  <mat-radio-button value="1" [checked]="selectedPriceType === 'flexPlus'">Flexi Plus</mat-radio-button>
                </div>
                <div class="pricing">
                  <p>
                    {{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                    item.flightfare.infantbasefare + item.flightfare.adulttax +
                    item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                    '2.0-0'
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'flexPlus'}">
              <mat-list class="item-lst" role="list">
                <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                <mat-list-item role="listitem"> Check-in baggage included</mat-list-item>
                <mat-list-item role="listitem"> Lower cancellation fees </mat-list-item>
                <mat-list-item role="listitem">Free date change allowed</mat-list-item>
                <mat-list-item role="listitem">Free seats available</mat-list-item>
              </mat-list>
            </div>
          </div>
          <div class="super-save" [ngClass]="{'switchicon': selectedPriceType === 'easyRefund'}">
            <div class="super-saver-top">
              <div class="super">
                <div class="radio-holder" (click)="togglePrice('easyRefund')">
                  <mat-radio-button value="1" [checked]="selectedPriceType === 'easyRefund'">Easy Refund</mat-radio-button>
                </div>
                <div class="pricing">
                  <p>
                    {{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                    item.flightfare.infantbasefare + item.flightfare.adulttax +
                    item.flightfare.childtax + item.flightfare.infanttax | currency: item.flightfare.currency: true:
                    '2.0-0'
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="item-incl" [ngClass]="{'switchicon': selectedPriceType === 'easyRefund'}">
              <mat-list class="item-lst" role="list">
                <mat-list-item role="listitem">Cabin baggage included</mat-list-item>
                <mat-list-item role="listitem"> Check-in baggage included</mat-list-item>
                <mat-list-item role="listitem"> Full refund of upto ₹ 5,655 (over and above airline refund) per person
                  per route if you cancel </mat-list-item>
                <mat-list-item role="listitem">Date change chargeable</mat-list-item>
              </mat-list>
            </div>
          </div>
        </div>
      </ng-container> -->

      <!--More fare detail ends here-->

      <div class="itineraryDetail">
        <ng-container *ngFor="let subItem of item.flightlegs">
          <div class="flightInformation mobile_view">
            <div class="flightInfo ">
              <img
                [src]="subItem[0]?.carrierImage ? subItem[0]?.carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                [alt]="subItem[0].carriername" class="img-fluid"
                onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
              <div class="carrierInfo">
                <p class="carriername">{{subItem[0].carriername}}</p>
                <p class="carrierNumber">{{subItem[0].carrier}}-{{subItem[0].flightnumber}}<span
                    *ngIf="subItem.length === 2"
                    class="stopageVia">,&nbsp;{{subItem[1].carrier}}-{{subItem[1].flightnumber}}</span>
                  <span *ngIf="subItem.length === 3"
                    class="stopageVia">,&nbsp;{{subItem[2].carrier}}-{{subItem[2].flightnumber}}</span>
                </p>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="itineraryInfo">
          <div class="extraInfo">
            <ul>
              <li class="baggage">
                <mat-icon>luggage</mat-icon>&nbsp;
                <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                  {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in luggage</span>
                </ng-container>
              </li>
              <!-- Food Meal -->
              <!-- <li class="meal">
                <ng-container *ngIf="item?.extra_info?.change?.length !== 0">
                  <mat-icon>restaurant</mat-icon>&nbsp;{{item.extra_info.change[0].value}}
                </ng-container>
                <ng-container *ngIf="item?.extra_info?.change?.length === 0"><span>
                    <mat-icon>no_meals</mat-icon>&nbsp;No Meal
                  </span></ng-container>
              </li> -->
            </ul>
          </div>
        </div>
        <!-- <button mat-icon-button (click)="showFlightDetails = !showFlightDetails" color="primary" class="closeBtn">
          <mat-icon>close</mat-icon>
        </button> -->
        <button mat-button (click)="showFlightDetails(i)">Flight Details
          <span *ngIf="flight_Details[i]">
            <mat-icon>close</mat-icon>
          </span>
          <span *ngIf="!flight_Details[i]">
            <mat-icon>expand_more</mat-icon>
          </span>
        </button>
      </div>
      <section class="flightDetailsSection" [ngClass]="{'d-block': flight_Details[i]}">
        <div class="flightMoreDeatiles">
          <div class="innerWrapper">
            <h4>Flight Details</h4>
            <ng-container *ngFor="let subItem of item['flightlegs']['0']; let i = index">
              <div class="flightItinerary">
                <div class="flightDitels">
                  <div class="flightInfo">
                    <img
                      [src]="subItem?.carrierImage ? subItem?.carrierImage : '../../../assets/b2c/flight/flight-dummy.png'"
                      [alt]="subItem.carriername" class="img-fluid"
                      onerror="this.src='../../../assets/b2c/flight/flight-dummy.png';">
                    <div class="carrierInfo">
                      <p class="carriername"><span>{{subItem.carriername}}</span>&nbsp;({{subItem.cabinclass}})</p>
                      <p>{{subItem.carrier}}-{{subItem.flightnumber}}</p>
                    </div>
                  </div>
                  <div class="extraInfo">
                    <p class="baggage">
                      <mat-icon>luggage</mat-icon>&nbsp;
                      <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                        {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                      <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in luggage</span>
                      </ng-container>
                    </p>
                  </div>
                </div>
                <div class="detailsFlightAirport">
                  <div class="flightInfoDetials">
                    <p>{{subItem.origin_name.slice(0, -5)}}</p>
                    <p class="time">{{utilities.transfromTimeToHourMin(subItem.deptime)}}</p>
                    <p class="date">{{subItem.depdate | date}}</p>
                    <p matTooltip="{{subItem.originAirportName}}">
                      {{subItem.originAirportName | slice:0:12}}...
                    </p>
                    <p>
                      Terminal {{subItem.depterminal || '-'}}
                    </p>
                  </div>
                  <div class="timeDuration">
                    <p> {{subItem.journeyduration * 1000 * 60 | date: 'H' : 'UTC'}}h {{subItem.journeyduration * 1000 *
                      60 | date: 'm' : 'UTC'}}m</p>
                    <span></span>
                  </div>
                  <div class="flightInfoDetials">
                    <p>{{subItem.destination_name.slice(0, -5)}}</p>
                    <p class="time">{{utilities.transfromTimeToHourMin(subItem.arrtime)}}</p>
                    <p class="date">{{subItem.arrdate | date}}</p>
                    <p matTooltip="{{subItem.destinationAirportName}}">
                      {{subItem.destinationAirportName | slice:0 :12}}...
                    </p>
                    <p>
                      Terminal {{subItem.arrterminal || '-'}}
                    </p>
                  </div>
                </div>
                <p class="overLayStrip">Change of Planes | {{item.layovers[0][item['flightlegs'][0][i].destination] |
                  date: 'h'}}h {{item.layovers[0][item['flightlegs'][0][i].destination] |
                  date: 'm'}}m layover in
                  {{subItem.destination_name.slice(0, -5)}}</p>
              </div>
            </ng-container>
          </div>
          <div class="innerWrapper"
            [ngClass]="(item?.extra_info?.cancel?.length === 0 || item?.extra_info?.change?.length === 0) ? 'changeColor':'' ">
            <h4>Fare summary</h4>
            <div class="fareSummary">
              <p>Base Fare<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                  item.flightfare.infantbasefare | currency: 'INR': true : '2.0-0' }}</span></p>
              <p>Fee & Surcharges<span>{{item.flightfare.adulttax + item.flightfare.childtax + item.flightfare.infanttax
                  | currency: 'INR': true : '2.0-0' }}</span></p>
              <!-- <p>Other Services<span>0</span></p> -->
              <p>Total Amount<span>{{item.flightfare.adultbasefare + item.flightfare.childbasefare +
                  item.flightfare.infantbasefare + item.flightfare.adulttax +
                  item.flightfare.childtax + item.flightfare.infanttax | currency: 'INR': true : '2.0-0' }} </span></p>
            </div>
            <!-- <div class="booknow_btn">
              <button mat-button class="secoundaryBtn">Book Now</button>
            </div> -->
          </div>

          <div class="innerWrapper" *ngIf="item?.extra_info?.cancel?.length !== 0">
            <h4>Fare Rules</h4>
            <div class="fareRules">
              <h5>Airline Cancellation Fee <span> {{item.extra_info.cancel[0].value}}</span></h5>
              <p>{{item.extra_info.cancel[0].rule}}</p>
            </div>
            <div class="fareRules" *ngIf="item?.extra_info?.change?.length !== 0">
              <h5>Airline Date Change Fee <span> {{item.extra_info.change[0].value}}</span></h5>
              <p>{{item.extra_info.change[0].rule}}</p>
            </div>
          </div>
        </div>
      </section>
    </mat-card>
  </ng-container>

</section>
<ng-container
  *ngIf="!(loaderService.isLoading | async) && !flightjourneys || (flightjourneys && flightjourneys.length === 0)">
  <div class="no_results-wrapper" *ngIf="this.isLoaded == true">
    <mat-card>
      <div class="error-wrapper text-center">
        <div class="no-results-img d-flex justify-content-center">
          <img src="../../../assets/b2c/flight/result-not-found.png" class="img-fluid">
        </div>
        <h1>No results found</h1>
        <p>
          Sorry! We could not find any flight for this search. Please search again
        </p>
        <div class="search_btn">
          <button mat-button class="secoundaryBtn">Search again</button>
        </div>

      </div>
    </mat-card>
  </div>
</ng-container>
